import { Component } from '@angular/core';
import { REPORT_POLLUTION_TO_EPA_URL_EXTERNAL } from '../models/external-urls';

@Component({
  selector: 'app-report-pollution',
  templateUrl: './report-pollution.component.html',
  styleUrls: ['./report-pollution.component.scss']
})
export class ReportPollutionComponent {
  public REPORT_POLLUTION_TO_EPA_URL = REPORT_POLLUTION_TO_EPA_URL_EXTERNAL;
}
